import "./LocalizationEdit.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import LocalizationEditComponentController from "./LocalizationEditComponentController";

export default class LocalizationEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = LocalizationEditComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Localization/EditForm/LocalizationEdit.html";
    }
}

module("mmAuth").component("mmLocalizationEdit", new LocalizationEditComponent());
